import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link } from '@rocketlane/rocket-router';
import { Space } from 'antd';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { Title, Description, LinkText, UserInfo } from 'components/atoms/form-elements';
import { RoutePaths } from 'constant';
import { ReactComponent as PaperplaneSVG } from 'routes/forgot-password/paper-plane.svg';
const PageTitle = styled(Title)`
  color: var(--black-100);
`;
const StyledSpace = styled(Space)`
  padding: 120px;
`;
export const SuccessPage = ({ email })=>{
    return /*#__PURE__*/ _jsxs(StyledSpace, {
        direction: "vertical",
        size: 16,
        children: [
            /*#__PURE__*/ _jsx(PaperplaneSVG, {}),
            /*#__PURE__*/ _jsxs(PageTitle, {
                children: [
                    /*#__PURE__*/ _jsx(FormattedMessage, {
                        id: "forgot_password.success"
                    }),
                    /*#__PURE__*/ _jsx("strong", {
                        children: email
                    }),
                    /*#__PURE__*/ _jsx("br", {}),
                    /*#__PURE__*/ _jsx(FormattedMessage, {
                        id: "forgot_password.success_msg"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Description, {
                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "forgot_password.success_help"
                })
            }),
            /*#__PURE__*/ _jsx(UserInfo, {
                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "forgot_password.cta_back",
                    values: {
                        a: (chunks)=>/*#__PURE__*/ _jsx(Link, {
                                to: RoutePaths.login,
                                children: /*#__PURE__*/ _jsx(LinkText, {
                                    children: chunks
                                })
                            })
                    }
                })
            })
        ]
    });
};
